import { render, staticRenderFns } from "./extra-events.vue?vue&type=template&id=3dac2e6e&lang=pug&"
import script from "./extra-events.vue?vue&type=script&lang=js&"
export * from "./extra-events.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports